module.exports = __webpack_public_path__ + "static/media/google_cloud.0d858bd9.svg";